import React from 'react';
import PageHeader from '../Layout/PageHeader';
import PersonAvatar from '../Layout/PersonAvatar';
import profileImage1 from '../../assets/images/Milos Vulic - selfie.png';
import profileImage2 from '../../assets/images/Lazar M.jpg';
import profileImage3 from '../../assets/images/Iva Vulic - selfie.jpg';
import profileImage4 from '../../assets/images/Nikola Markovic - selfie.png';
import profileImage6 from '../../assets/images/Jelena Ilic - selfie.png';
import profileImage7 from '../../assets/images/Adam Gyurjyan - selfie.png';

const teamMembers = [
  {
    id: 1,
    name: 'Miloš Vulić',
    role: 'CEO | Android & Backend Developer',
    description: 'Leads product vision and hands-on development across Android and backend systems.',
    image: profileImage1,
    scalerClass: 'person-card__avatar-scaler--milos',
  },
  {
    id: 2,
    name: 'Lazar Miladinović',
    role: 'Designer',
    description: 'Creates visual identities, UI systems, and brand experiences for digital products.',
    image: profileImage2,
  },
  {
    id: 3,
    name: 'Iva Vulic',
    role: 'Designer',
    description: 'Brings creative direction and polished design to every client-facing experience.',
    image: profileImage3,
    scalerClass: 'person-card__avatar-scaler--iva',
  },
  {
    id: 4,
    name: 'Nikola Marković',
    role: 'QA / Project Manager',
    description: 'Ensures quality, delivery timelines, and smooth collaboration across projects.',
    image: profileImage4,
  },
  {
    id: 6,
    name: 'Jelena Ilić',
    role: 'Web Developer',
    description: 'Develops modern, responsive web experiences with clean and maintainable code.',
    image: profileImage6,
    scalerClass: 'person-card__avatar-scaler--jelena',
  },
  {
    id: 7,
    name: 'Adam Gyurjyan',
    role: 'Backend Developer',
    description: 'Builds reliable APIs, server-side systems, and backend architecture for scalable products.',
    image: profileImage7,
    scalerClass: 'person-card__avatar-scaler--adam',
  },
];

const Team = () => {
  return (
    <main className="page">
      <div className="page__inner">
        <PageHeader
          label="Team"
          title="Meet the people behind NeoApps"
          description="A multidisciplinary team of developers, designers, and product specialists working together to ship great software."
        />

        <div className="grid-3">
          {teamMembers.map((member) => (
            <article key={member.id} className="surface-card person-card">
              <PersonAvatar src={member.image} alt={member.name} scalerClass={member.scalerClass} />
              <h3 className="person-card__name">{member.name}</h3>
              <p className="person-card__role">{member.role}</p>
              <p className="person-card__bio">{member.description}</p>
            </article>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Team;
